import { useState, useCallback } from "react";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { recipeToCreatePayload, INGREDIENT_SLOTS } from "./recipeIngredients";


const useRecipeutils =()=>{
    
    const [recipiename, setRecipiename] = useState("");
    const [recipieslist, setRecipieslist] = useState([]);
    const [favoriteIds, setFavoriteIds] = useState([]);
    const [measurement1, setMeasurement1] = useState("cups");
    const [measurement2, setMeasurement2] = useState("cups");
    const [measurement3, setMeasurement3] = useState("cups");
    const [measurement4, setMeasurement4] = useState("cups");
    const [measurement5, setMeasurement5] = useState("cups");
    const [measurement6, setMeasurement6] = useState("cups");
    const [measurement7, setMeasurement7] = useState("cups");
    const [measurement8, setMeasurement8] = useState("cups");
    const [measurement9, setMeasurement9] = useState("cups");
    const [measurement10, setMeasurement10] = useState("cups");
    const [measurement11, setMeasurement11] = useState("cups");
    const [measurement12, setMeasurement12] = useState("cups");
    const [ingediant1, setIngediant1] = useState("");
    const [ingediant2, setIngediant2] = useState("");
    const [ingediant3, setIngediant3] = useState("");
    const [ingediant4, setIngediant4] = useState("");
    const [ingediant5, setIngediant5] = useState("");
    const [ingediant6, setIngediant6] = useState("");
    const [ingediant7, setIngediant7] = useState("");
    const [ingediant8, setIngediant8] = useState("");
    const [ingediant9, setIngediant9] = useState("");
    const [ingediant10, setIngediant10] = useState("");
    const [ingediant11, setIngediant11] = useState("");
    const [ingediant12, setIngediant12] = useState("");
    const [ingediant1num, setIngediant1num] = useState(0);
  const [ingediant2num, setIngediant2num] = useState(0);
  const [ingediant3num, setIngediant3num] = useState(0);
  const [ingediant4num, setIngediant4num] = useState(0);
  const [ingediant5num, setIngediant5num] = useState(0);
  const [ingediant6num, setIngediant6num] = useState(0);
  const [ingediant7num, setIngediant7num] = useState(0);
  const [ingediant8num, setIngediant8num] = useState(0);
  const [ingediant9num, setIngediant9num] = useState(0);
  const [ingediant10num, setIngediant10num] = useState(0);
  const [ingediant11num, setIngediant11num] = useState(0);
  const [ingediant12num, setIngediant12num] = useState(0);
const [searchTerm, setSearchTerm] = useState("")
  const [notes, setNotes] = useState("");
  const [newnotes, setNewnotes] = useState("");
  const [newrecipiename, setNewrecipiename] = useState("");
  const [times,setTimes] = useState(0);

    const axiosPrivate = useAxiosPrivate();

    

    const [buildname, setBuildname] = useState("");
    const [buildpropslist, setBuildpropslist] = useState([]);
    const [buildId, setBuildId] = useState(0);
    const [buildDescription, setBuildDescription] = useState("");
    const [buildimagepath,setBuildimagepath] = useState("");
    const [buildimagepath2, setBuildimagepath2] = useState("");
    const [buildprops, setBuildprops] = useState("")


    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    
   

    
    const addRecipieprops = async (overrides = {}) => {
      const payload = {
        buildname: overrides.buildname ?? buildname,
        buildId: overrides.buildId ?? buildId,
        buildDescription: overrides.buildDescription ?? buildDescription,
        buildimagepath: overrides.buildimagepath ?? buildimagepath,
        buildimagepath2: overrides.buildimagepath2 ?? buildimagepath2,
      };

      await axiosPrivate.post("recipies/buildprops", {
        mode: 'cors',
        ...payload,
      }).then(() => {
        setBuildpropslist([
          ...buildpropslist,
          {
            mode: 'cors',
            ...payload,
          },
        ]);
      });
    };
    
    const addImglink = async (overrides = {}) => {
      const payload = {
        buildname: overrides.buildname ?? buildname,
        buildId: overrides.buildId ?? buildId,
        buildDescription: overrides.buildDescription ?? buildDescription,
        buildimagepath: overrides.buildimagepath ?? buildimagepath,
        buildimagepath2: overrides.buildimagepath2 ?? buildimagepath2,
      };

      await axiosPrivate.post("recipies/buildprops/imglink", {
        mode: 'cors',
        buildId: payload.buildId,
        buildimagepath: payload.buildimagepath,
      }).then(() => {
        setBuildpropslist([
          ...buildpropslist,
          {
            mode: 'cors',
            ...payload,
          },
        ]);
      });
    };
  
     
    const getBuildprops = useCallback( async (buildimagepath) => {
        
      // locationlock();
      
 const encodedPath = encodeURIComponent(buildimagepath);
         const response = await axiosPrivate.get(`/recipies/buildprops/${encodedPath}`);
         if (!response.data?.length) {
           console.warn('No build props found for', buildimagepath);
           return;
         }
         setBuildprops(response.data);
         setBuildname(response.data[0].buildname);
         setBuildId(response.data[0].buildId);
         setBuildDescription(response.data[0].buildDescription);
         setBuildimagepath(response.data[0].buildimagepath);
         setBuildimagepath2(response.data[0].buildimagepath2);
     },[axiosPrivate])
     

    const getRecipies = useCallback(async (url) => {
        try {
            const response = await axiosPrivate.get(url);
            setRecipieslist(response.data);
        } catch (err) {
            if (err.response?.status === 429) {
                const retryAfter = err.response.headers?.['retry-after'];
                const waitMsg = retryAfter
                    ? `Please wait ${Math.ceil(Number(retryAfter) / 60)} minutes and try again.`
                    : 'Please wait a few minutes and try again.';
                const rateErr = new Error(`Too many requests. ${waitMsg}`);
                rateErr.isRateLimited = true;
                throw rateErr;
            }
            throw err;
        }
    }, [axiosPrivate]);

    const loadFavoriteIds = useCallback(async () => {
        try {
            const response = await axiosPrivate.get('/recipies/favorites/ids');
            setFavoriteIds(response.data);
        } catch (err) {
            if (err.response?.status !== 429) throw err;
        }
    }, [axiosPrivate]);

    const isFavorite = useCallback(
        (id) => favoriteIds.includes(id),
        [favoriteIds]
    );

    const toggleFavorite = useCallback(async (id, onFavoritesTab = false) => {
        const favorited = favoriteIds.includes(id);
        if (favorited) {
            await axiosPrivate.delete(`/recipies/${id}/favorite`);
            setFavoriteIds((prev) => prev.filter((favId) => favId !== id));
            if (onFavoritesTab) {
                setRecipieslist((prev) => prev.filter((recipe) => recipe.id !== id));
            }
        } else {
            await axiosPrivate.post(`/recipies/${id}/favorite`);
            setFavoriteIds((prev) => [...prev, id]);
        }
    }, [axiosPrivate, favoriteIds]);

    const publishRecipe = useCallback(async (id) => {
        await axiosPrivate.put(`/recipies/${id}/publish`);
        setRecipieslist((prev) =>
            prev.map((recipe) =>
                recipe.id === id ? { ...recipe, visibility: 'public' } : recipe
            )
        );
    }, [axiosPrivate]); // throws on 402 — caller handles upgrade messaging
       /*const getRecipies = async  () => {
        // locationlock();
        await axiosPrivate.get("/recipies").then((response) => {
           setRecipieslist(response.data);
           window.scrollTo(0, 1000);
         });
       };*/

       
       const resetIngediantNumber = async (id) => {
        await axiosPrivate.put("recipies/recipenotes", {
          mode: 'cors',
          times: times,
          id: id,
        }).then(
          (response) => {
            setRecipieslist(recipieslist.map((val, key) => {
              return val.id === id ? {
                recipiename: val.recipiename,
                id: val.id,
                measurement1: val.measurement1,
                measurement2: val.measurement2,
                measurement3: val.measurement3,
                measurement4: val.measurement4,
                measurement5: val.measurement5,
                measurement6: val.measurement6,
                measurement7: val.measurement7,
                measurement8: val.measurement8,
                measurement9: val.measurement9,
                measurement10: val.measurement10,
                measurement11: val.measurement11,
                measurement12: val.measurement12,
                ingediant1: val.ingediant1,
                ingediant2: val.ingediant2,
                ingediant3: val.ingediant3,
                ingediant4: val.ingediant4,
                ingediant5: val.ingediant5,
                ingediant6: val.ingediant6,
                ingediant7: val.ingediant7,
                ingediant8: val.ingediant8,
                ingediant9: val.ingediant9,
                ingediant10: val.ingediant10,
                ingediant11: val.ingediant11,
                ingediant12: val.ingediant12,
                ingediant1num: val.ingediant1num/times,
                ingediant2num: val.ingediant2num/times,
                ingediant3num: val.ingediant3num/times,
                ingediant4num: val.ingediant4num/times,
                ingediant5num: val.ingediant5num/times,
                ingediant6num: val.ingediant6num/times,
                ingediant7num: val.ingediant7num/times,
                ingediant8num: val.ingediant8num/times,
                ingediant9num: val.ingediant9num/times,
                ingediant10num: val.ingediant10num/times,
                ingediant11num: val.ingediant11num/times,
                ingediant12num: val.ingediant12num/times,
                notes: val.notes
              } : val
            }));
          }
        );
      };
    

      const updateRecipiename = async (id) => {
        await axiosPrivate.put("recipies/recipename", {
          mode: 'cors',
          recipiename: newrecipiename,
          id: id,
        }).then(
          (response) => {
            setRecipieslist(recipieslist.map((val) => {
              return val.id === id ? {
                recipiename: newrecipiename,
                id: val.id,
                measurement1: val.measurement1,
                measurement2: val.measurement2,
                measurement3: val.measurement3,
                measurement4: val.measurement4,
                measurement5: val.measurement5,
                measurement6: val.measurement6,
                measurement7: val.measurement7,
                measurement8: val.measurement8,
                measurement9: val.measurement9,
                measurement10: val.measurement10,
                measurement11: val.measurement11,
                measurement12: val.measurement12,
                ingediant1: val.ingediant1,
                ingediant2: val.ingediant2,
                ingediant3: val.ingediant3,
                ingediant4: val.ingediant4,
                ingediant5: val.ingediant5,
                ingediant6: val.ingediant6,
                ingediant7: val.ingediant7,
                ingediant8: val.ingediant8,
                ingediant9: val.ingediant9,
                ingediant10: val.ingediant10,
                ingediant11: val.ingediant11,
                ingediant12: val.ingediant12,
                ingediant1num: val.ingediant1num,
                ingediant2num: val.ingediant2num,
                ingediant3num: val.ingediant3num,
                ingediant4num: val.ingediant4num,
                ingediant5num: val.ingediant5num,
                ingediant6num: val.ingediant6num,
                ingediant7num: val.ingediant7num,
                ingediant8num: val.ingediant8num,
                ingediant9num: val.ingediant9num,
                ingediant10num: val.ingediant10num,
                ingediant11num: val.ingediant11num,
                ingediant12num: val.ingediant12num,
                notes: val.notes
              } : val
            }));
          }
        );
      };
    






      const updateNotes = async (id) => {
        await axiosPrivate.put("recipies/recipenotes", {
          mode: 'cors',
          notes: newnotes,
          id: id,
        }).then(
          (response) => {
            setRecipieslist(recipieslist.map((val, key) => {
              return val.id === id ? {
                recipiename: val.recipiename,
                id: val.id,
                measurement1: val.measurement1,
                measurement2: val.measurement2,
                measurement3: val.measurement3,
                measurement4: val.measurement4,
                measurement5: val.measurement5,
                measurement6: val.measurement6,
                measurement7: val.measurement7,
                measurement8: val.measurement8,
                measurement9: val.measurement9,
                measurement10: val.measurement10,
                measurement11: val.measurement11,
                measurement12: val.measurement12,
                ingediant1: val.ingediant1,
                ingediant2: val.ingediant2,
                ingediant3: val.ingediant3,
                ingediant4: val.ingediant4,
                ingediant5: val.ingediant5,
                ingediant6: val.ingediant6,
                ingediant7: val.ingediant7,
                ingediant8: val.ingediant8,
                ingediant9: val.ingediant9,
                ingediant10: val.ingediant10,
                ingediant11: val.ingediant11,
                ingediant12: val.ingediant12,
                ingediant1num: val.ingediant1num,
                ingediant2num: val.ingediant2num,
                ingediant3num: val.ingediant3num,
                ingediant4num: val.ingediant4num,
                ingediant5num: val.ingediant5num,
                ingediant6num: val.ingediant6num,
                ingediant7num: val.ingediant7num,
                ingediant8num: val.ingediant8num,
                ingediant9num: val.ingediant9num,
                ingediant10num: val.ingediant10num,
                ingediant11num: val.ingediant11num,
                ingediant12num: val.ingediant12num,
                notes: newnotes
              } : val
            }));
          }
        );
      };


  const newIngediantNumber = async (id) => {
    await axiosPrivate.put("recipies/recipenotes", {
      mode: 'cors',
      times: times,
      id: id,
    }).then(
      (response) => {
        setRecipieslist(recipieslist.map((val, key) => {
          return val.id === id ? {
            recipiename: val.recipiename,
            id: val.id,
            measurement1: val.measurement1,
            measurement2: val.measurement2,
            measurement3: val.measurement3,
            measurement4: val.measurement4,
            measurement5: val.measurement5,
            measurement6: val.measurement6,
            measurement7: val.measurement7,
            measurement8: val.measurement8,
            measurement9: val.measurement9,
            measurement10: val.measurement10,
            measurement11: val.measurement11,
            measurement12: val.measurement12,
            ingediant1: val.ingediant1,
            ingediant2: val.ingediant2,
            ingediant3: val.ingediant3,
            ingediant4: val.ingediant4,
            ingediant5: val.ingediant5,
            ingediant6: val.ingediant6,
            ingediant7: val.ingediant7,
            ingediant8: val.ingediant8,
            ingediant9: val.ingediant9,
            ingediant10: val.ingediant10,
            ingediant11: val.ingediant11,
            ingediant12: val.ingediant12,
            ingediant1num: val.ingediant1num*times,
            ingediant2num: val.ingediant2num*times,
            ingediant3num: val.ingediant3num*times,
            ingediant4num: val.ingediant4num*times,
            ingediant5num: val.ingediant5num*times,
            ingediant6num: val.ingediant6num*times,
            ingediant7num: val.ingediant7num*times,
            ingediant8num: val.ingediant8num*times,
            ingediant9num: val.ingediant9num*times,
            ingediant10num: val.ingediant10num*times,
            ingediant11num: val.ingediant11num*times,
            ingediant12num: val.ingediant12num*times,
            notes: val.notes
          } : val
        }));
      }
    );
  };


    
  

  const buildRecipePayload = () => ({
    visibility: 'private',
    recipiename,
    measurement1, measurement2, measurement3, measurement4,
    measurement5, measurement6, measurement7, measurement8,
    measurement9, measurement10, measurement11, measurement12,
    ingediant1, ingediant2, ingediant3, ingediant4,
    ingediant5, ingediant6, ingediant7, ingediant8,
    ingediant9, ingediant10, ingediant11, ingediant12,
    ingediant1num, ingediant2num, ingediant3num, ingediant4num,
    ingediant5num, ingediant6num, ingediant7num, ingediant8num,
    ingediant9num, ingediant10num, ingediant11num, ingediant12num,
    notes,
  });

  const throwPlanLimit = (err) => {
    if (err.response?.status === 402) {
      const limitErr = new Error(err.response.data?.message || 'Recipe limit reached.');
      limitErr.isPlanLimit = true;
      throw limitErr;
    }
    throw err;
  };

  const addRecipie = async () => {
    if (!recipiename?.trim()) {
      throw new Error('Give your recipe a name first.');
    }
    const response = await axiosPrivate.post('/recipies', buildRecipePayload()).catch(throwPlanLimit);
    const created = response.data;
    setRecipieslist([
      ...recipieslist,
      {
        ...buildRecipePayload(),
        id: created.id,
        owner_username: created.owner_username,
        visibility: created.visibility || 'private',
      },
    ]);
  };

  const copyRecipe = async (recipe, { name, source } = {}) => {
    const payload = recipeToCreatePayload(recipe, { name, source });
    const response = await axiosPrivate.post('/recipies', payload).catch(throwPlanLimit);
    return response.data;
  };

  const emptyIngredientState = () => {
    const next = {};
    INGREDIENT_SLOTS.forEach((n) => {
      next[`measurement${n}`] = 'Cups';
      next[`ingediant${n}`] = '';
      next[`ingediant${n}num`] = 0;
    });
    return next;
  };

  const resetRecipeForm = () => {
    setRecipiename('');
    setNotes('');
    const empty = emptyIngredientState();
    setMeasurement1(empty.measurement1);
    setMeasurement2(empty.measurement2);
    setMeasurement3(empty.measurement3);
    setMeasurement4(empty.measurement4);
    setMeasurement5(empty.measurement5);
    setMeasurement6(empty.measurement6);
    setMeasurement7(empty.measurement7);
    setMeasurement8(empty.measurement8);
    setMeasurement9(empty.measurement9);
    setMeasurement10(empty.measurement10);
    setMeasurement11(empty.measurement11);
    setMeasurement12(empty.measurement12);
    setIngediant1(empty.ingediant1);
    setIngediant2(empty.ingediant2);
    setIngediant3(empty.ingediant3);
    setIngediant4(empty.ingediant4);
    setIngediant5(empty.ingediant5);
    setIngediant6(empty.ingediant6);
    setIngediant7(empty.ingediant7);
    setIngediant8(empty.ingediant8);
    setIngediant9(empty.ingediant9);
    setIngediant10(empty.ingediant10);
    setIngediant11(empty.ingediant11);
    setIngediant12(empty.ingediant12);
    setIngediant1num(empty.ingediant1num);
    setIngediant2num(empty.ingediant2num);
    setIngediant3num(empty.ingediant3num);
    setIngediant4num(empty.ingediant4num);
    setIngediant5num(empty.ingediant5num);
    setIngediant6num(empty.ingediant6num);
    setIngediant7num(empty.ingediant7num);
    setIngediant8num(empty.ingediant8num);
    setIngediant9num(empty.ingediant9num);
    setIngediant10num(empty.ingediant10num);
    setIngediant11num(empty.ingediant11num);
    setIngediant12num(empty.ingediant12num);
  };

  const updateRecipe = async (id, payload) => {
    const response = await axiosPrivate.put(`/recipies/${id}`, payload);
    setRecipieslist((prev) =>
      prev.map((recipe) => (recipe.id === id ? { ...recipe, ...payload } : recipe))
    );
    return response.data;
  };

  const deleteRecipe = async (id) => {
    await axiosPrivate.delete(`/recipies/${id}`);
    setRecipieslist(recipieslist.filter((val) => val.id !== id));
  };

  const confirmDelete = async (id) => {
    if (window.confirm('Delete this recipe? This cannot be undone.')) {
      await deleteRecipe(id);
    }
  };
  const [recipie, setRecipie] = useState([]);
  const getRecipie = async (id) => {
    
      await axiosPrivate.get(`/recipies/recipe/${id}`, {
        id: id,
      }).then((response) => {
        setRecipie(response.data);
      }
      );
  }


    
    return{recipiename, setRecipiename, getRecipies, recipieslist, setRecipieslist,
        favoriteIds, loadFavoriteIds, isFavorite, toggleFavorite, publishRecipe,
        measurement1, setMeasurement1, measurement2, 
        setMeasurement2, measurement3, setMeasurement3, measurement4, setMeasurement4,
        measurement5, setMeasurement5, measurement6, 
        setMeasurement6, measurement7, setMeasurement7, measurement8, setMeasurement8,
        measurement9, setMeasurement9, measurement10, 
        setMeasurement10, measurement11, setMeasurement11, measurement12, setMeasurement12,
        ingediant1, setIngediant1, ingediant2, 
        setIngediant2, ingediant3, setIngediant3, ingediant4, setIngediant4,
        ingediant5, setIngediant5, ingediant6, 
        setIngediant6, ingediant7, setIngediant7, ingediant8, setIngediant8,
        ingediant9, setIngediant9, ingediant10, 
        setIngediant10, ingediant11, setIngediant11, ingediant12, setIngediant12,
        ingediant1num, setIngediant1num, ingediant2num, 
        setIngediant2num, ingediant3num, setIngediant3num, ingediant4num, setIngediant4num,
        ingediant5num, setIngediant5num, ingediant6num, 
        setIngediant6num, ingediant7num, setIngediant7num, ingediant8num, setIngediant8num,
        ingediant9num, setIngediant9num, ingediant10num, 
        setIngediant10num, ingediant11num, setIngediant11num, ingediant12num, setIngediant12num,
        searchTerm, setSearchTerm,
        notes, setNotes,
        newnotes, setNewnotes,
        newrecipiename, setNewrecipiename,
        times,setTimes,
        resetIngediantNumber,
        updateRecipiename,
        updateNotes,
        addRecipie,
        copyRecipe,
        updateRecipe,
        resetRecipeForm,
        newIngediantNumber, getBuildprops, getRecipie, recipie, setRecipie,
        deleteRecipe, confirmDelete, addRecipieprops, addImglink, buildname, setBuildname, buildpropslist, setBuildpropslist, buildId, setBuildId, buildDescription, setBuildDescription,
        buildimagepath,setBuildimagepath, buildimagepath2, setBuildimagepath2, buildprops, setBuildprops, show, setShow, handleClose , handleShow
    }
}

export default useRecipeutils